module.exports = __webpack_public_path__ + "img/kt-logo.dabc3181.png";